// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1vqVd","productName":"Table_productName__WXkAf"};